export const TRACK_HEIGHT = 56;
export const CIRCLE_Y = 34;
export const AXIS_Y = 55;

export const CIRCLE_SIZE = 22;
export const SELECTED_CIRCLE_SIZE = 30;

export const MINIMAP_HEIGHT = 24;
export const MINIMAP_TICK_WIDTH = 3;
